var _defs, _g, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBlacknutPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ClipPath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ClipPath-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.243 6.757h-30.486c-1.657 0-3 1.343-3 3v30.486c0 1.657 1.343 3 3 3h30.486c1.657 0 3-1.343 3-3v-17.648c0-1.657 1.343-3 3-3h.757c1.657 0 3 1.343 3 3v19.405c0 4.418-3.582 8-8 8h-34c-4.418 0-8-3.582-8-8v-34c0-4.418 3.582-8 8-8h34c4.418 0 8 3.582 8 8v2.514c0 1.656-1.343 3-3 3h-0.757c-1.657 0-3-1.344-3-3v-0.757c0-1.657-1.343-3-3-3Z",
    fill: "currentColor"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.002 14.5c-0.892 0-1.615 .723-1.615 1.615v17.77c0 .892 .723 1.615 1.615 1.615c.892 0 1.616-0.723 1.616-1.615v-17.77c0-0.892-0.724-1.615-1.616-1.615Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.387 16.115c0-1.444 1.171-2.615 2.615-2.615c1.444 0 2.616 1.171 2.616 2.615v17.77c0 1.444-1.172 2.615-2.616 2.615c-1.444 0-2.615-1.171-2.615-2.615v-17.77Zm1 0c0-0.892 .723-1.615 1.615-1.615c.892 0 1.616 .723 1.616 1.615v17.77c0 .892-0.724 1.615-1.616 1.615c-0.892 0-1.615-0.723-1.615-1.615v-17.77Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.115 23.385c-0.892 0-1.615 .723-1.615 1.615c0 .892 .723 1.616 1.615 1.616h17.77c.892 0 1.615-0.724 1.615-1.616c0-0.892-0.723-1.615-1.615-1.615h-17.77Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 25c0-1.444 1.171-2.615 2.615-2.615h17.77c1.444 0 2.615 1.171 2.615 2.615c0 1.445-1.171 2.616-2.615 2.616h-17.77c-1.444 0-2.615-1.171-2.615-2.616Zm1 0c0-0.892 .723-1.615 1.615-1.615h17.77c.892 0 1.615 .723 1.615 1.615c0 .892-0.723 1.616-1.615 1.616h-17.77c-0.892 0-1.615-0.724-1.615-1.616Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBlacknutPlus);
export default __webpack_public_path__ + "static/media/ic_blacknut_plus.98dda4751f8c40b74150e21bbc86100f.svg";
export { ForwardRef as ReactComponent };